"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyExperimentPayloadToJSON = exports.CopyExperimentPayloadFromJSONTyped = exports.CopyExperimentPayloadFromJSON = exports.instanceOfCopyExperimentPayload = void 0;
var runtime_1 = require("../runtime");
var CopyExperimentConfig_1 = require("./CopyExperimentConfig");
/**
 * Check if a given object implements the CopyExperimentPayload interface.
 */
function instanceOfCopyExperimentPayload(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCopyExperimentPayload = instanceOfCopyExperimentPayload;
function CopyExperimentPayloadFromJSON(json) {
    return CopyExperimentPayloadFromJSONTyped(json, false);
}
exports.CopyExperimentPayloadFromJSON = CopyExperimentPayloadFromJSON;
function CopyExperimentPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentConfigs': !(0, runtime_1.exists)(json, 'experiment_configs') ? undefined : (json['experiment_configs'].map(CopyExperimentConfig_1.CopyExperimentConfigFromJSON)),
        'generatedAtEpochMs': !(0, runtime_1.exists)(json, 'generated_at_epoch_ms') ? undefined : json['generated_at_epoch_ms'],
    };
}
exports.CopyExperimentPayloadFromJSONTyped = CopyExperimentPayloadFromJSONTyped;
function CopyExperimentPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_configs': value.experimentConfigs === undefined ? undefined : (value.experimentConfigs.map(CopyExperimentConfig_1.CopyExperimentConfigToJSON)),
        'generated_at_epoch_ms': value.generatedAtEpochMs,
    };
}
exports.CopyExperimentPayloadToJSON = CopyExperimentPayloadToJSON;
